var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-photo 2",
    clipPath: "url(#clip0_736_3400)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.48849 2.79536C3.78203 2.50182 4.18015 2.33691 4.59527 2.33691H6.51087C6.79903 2.33691 7.03261 2.57051 7.03261 2.85865C7.03261 3.1468 6.79903 3.38039 6.51087 3.38039H4.59527C4.45689 3.38039 4.32419 3.43536 4.22634 3.5332L3.79412 3.96543C3.50058 4.25896 3.10246 4.42387 2.68734 4.42387H1.81522C1.52707 4.42387 1.29348 4.65746 1.29348 4.94561V10.163C1.29348 10.4512 1.52707 10.6847 1.81522 10.6847H9.11957C9.40772 10.6847 9.6413 10.4512 9.6413 10.163V6.51083C9.6413 6.22267 9.87489 5.98909 10.163 5.98909C10.4512 5.98909 10.6848 6.22267 10.6848 6.51083V10.163C10.6848 11.0275 9.98403 11.7282 9.11957 11.7282H1.81522C0.950774 11.7282 0.25 11.0275 0.25 10.163V4.94561C0.25 4.08117 0.950774 3.38039 1.81522 3.38039H2.68734C2.82572 3.38039 2.95842 3.32542 3.05627 3.22758L3.48849 2.79536Z",
    fill: "#1253FA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8587 7.55425C2.8587 6.11352 4.02666 4.94556 5.4674 4.94556C6.90813 4.94556 8.07609 6.11352 8.07609 7.55425C8.07609 8.99498 6.90813 10.1629 5.4674 10.1629C4.02666 10.1629 2.8587 8.99498 2.8587 7.55425ZM5.4674 5.98903C4.60296 5.98903 3.90218 6.68978 3.90218 7.55425C3.90218 8.41872 4.60296 9.11947 5.4674 9.11947C6.33187 9.11947 7.03262 8.41872 7.03262 7.55425C7.03262 6.68978 6.33187 5.98903 5.4674 5.98903Z",
    fill: "#1253FA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.07611 2.85865C8.07611 2.57051 8.30969 2.33691 8.59785 2.33691H11.7283C12.0164 2.33691 12.25 2.57051 12.25 2.85865C12.25 3.1468 12.0164 3.38039 11.7283 3.38039H8.59785C8.30969 3.38039 8.07611 3.1468 8.07611 2.85865Z",
    fill: "#1253FA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.163 0.771729C10.4512 0.771729 10.6848 1.00532 10.6848 1.29347V4.4239C10.6848 4.71205 10.4512 4.94564 10.163 4.94564C9.87488 4.94564 9.6413 4.71205 9.6413 4.4239V1.29347C9.6413 1.00532 9.87488 0.771729 10.163 0.771729Z",
    fill: "#1253FA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_736_3400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPhoto);
export default __webpack_public_path__ + "static/media/add-photo.2eb10b6650d4c525c015c481eb0d758f.svg";
export { ForwardRef as ReactComponent };